import curry from 'lodash/curry';
import every from 'lodash/every';
import keys from 'lodash/keys';
import { isDefined } from './isDefined';

type JsTypes = 'undefined' | 'object' | 'boolean' | 'number' | 'string' | 'symbol' | 'function' | 'bigint';

interface StructureChecker {
    value: object;
    optionalKeys?: string[];
    strictOptionalKeysCheck?: boolean;
}

// Shallow object structure check
function hasStructure(
    { value, optionalKeys = [], strictOptionalKeysCheck = false }: StructureChecker,
    structure: { [key: string]: JsTypes },
): boolean {
    const isOptionalKey = (key: string) => optionalKeys.includes(key);
    const hasCorrectKeys = (checked: any) => keys(structure).every(key => isDefined(checked[key]));
    const hasCorrectValues = (checked: any) =>
        every(structure, (type, key) => {
            return typeof checked[key] === type || (isOptionalKey(key) && !strictOptionalKeysCheck);
        });

    return hasCorrectKeys(value) && hasCorrectValues(value);
}

const structureChecker = curry(hasStructure);

export { structureChecker };
